var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { SimpleForm } from 'react-admin';
import { required } from 'ra-core';
import { FORM_ERROR } from 'final-form';
import { makeStyles } from '@material-ui/core';
import { NewPasswordToolbar } from './NewPasswordToolbar';
import { PasswordInput } from '../../ui';
import { validatePassword } from '../validatePassword';
export const NewPasswordForm = props => {
    const { onSubmit, toolbarProps } = props, rest = __rest(props, ["onSubmit", "toolbarProps"]);
    const classes = useStyles(props);
    const validate = ({ password, confirm_password }) => {
        if (password !== confirm_password) {
            return {
                [FORM_ERROR]: 'apihub.new_password.validation.error_password_match',
            };
        }
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(SimpleForm, Object.assign({ className: classes.form, save: onSubmit, toolbar: React.createElement(NewPasswordToolbar, Object.assign({}, toolbarProps)), validate: validate }, rest),
            React.createElement(PasswordInput, { source: "password", label: "apihub.new_password.fields.password", fullWidth: true, variant: "outlined", validate: [required(), validatePassword], title: "apihub.new_password.validation.tooltip_password" }),
            React.createElement(PasswordInput, { source: "confirm_password", label: "apihub.new_password.fields.confirm_password", variant: "outlined", fullWidth: true, validate: required(), title: "apihub.new_password.validation.tooltip_password_confirm" }))));
};
const useStyles = makeStyles(theme => ({
    root: {},
    form: {
        '& >:first-child': {
            padding: 0,
        },
        '& .ra-input': {
            marginTop: theme.spacing(2),
        },
    },
}), {
    name: 'Layer7NewPasswordForm',
});
//# sourceMappingURL=NewPasswordForm.js.map